<script setup lang="ts">
import { useHomeRoute } from '../composables/useHomeRoute';
import { useRouter } from 'vue-router';
import AppLogo from './AppLogo.vue';
import LocaleSelect from './LocaleSelect.vue';
import errorImg from '../../images/asset-error.svg';
import accessImg from '../../images/asset-access.svg';
import notFoundImg from '../../images/asset-404.svg';
import { computed } from 'vue';

const { push: navigateToHome } = useHomeRoute();

const { currentRoute } = useRouter();

const imgSrc = computed(() => {
    switch (currentRoute.value.meta.layout) {
        case 'error':
            return errorImg;
        case 'not-found':
            return notFoundImg;
        case 'access-denied':
            return accessImg;
        default:
            return null;
    }
});
</script>

<template>
    <div
        class="error-layout"
        :class="`error-layout-${currentRoute.meta.layout}`"
    >
        <div
            class="error-layout-topbar flex align-items-center py-0 px-3 w-full z-2 px-5"
        >
            <a id="logolink" @click="navigateToHome">
                <AppLogo full height="3rem" />
            </a>

            <LocaleSelect />
        </div>

        <div
            class="error-layout-content-wrapper flex flex-column justify-content-center align-items-center px-4"
        >
            <div
                class="error-layout-content flex flex-column justify-content-center align-items-center text-center"
            >
                <img
                    v-if="imgSrc !== null"
                    class="error-img"
                    alt="${currentRoute.meta.layout}"
                    :src="imgSrc"
                />
                <router-view></router-view>
            </div>
            <!-- <div class="error-layout-footer flex align-items-center pt-8">
                 <h4 class="m-0 mr-5">App Name Here</h4>
                 <h6 class="m-0 mt-1 text-300 font-medium">Copyright Ⓒ Shrd BV.</h6>
                 </div> -->
        </div>
    </div>
</template>

<style lang="scss">
.error-layout-topbar {
    display: flex;
    justify-content: space-between;
    height: 62px;
    box-shadow: 0 10px 40px 0 rgb(41 50 65 / 6%);
    background-color: var(--surface-card);
}

.error-layout-content-wrapper {
    min-height: calc(100vh - 62px);
}

.error-img {
    width: 332px;
    height: 271px;
}
</style>
